import { AdvancedAbortController } from '../../misc/advanced-abort-controller/implementation';
import { IsObject } from '../../helpers';
import { IsAdvancedAbortSignal } from '../../misc/advanced-abort-controller/advanced-abort-signal/constructor';
export function NormalizeICancellablePromiseOptionsStrategy(strategy, defaultValue = 'never') {
    switch (strategy) {
        case void 0:
            return defaultValue;
        case 'resolve':
        case 'reject':
        case 'never':
            return strategy;
        default:
            throw new TypeError(`Expected 'resolve', 'reject', 'never' or void as options.strategy`);
    }
}
export function NormalizeICancellablePromiseOptionsSignal(signal, defaultValue = new AdvancedAbortController().signal) {
    if (signal === void 0) {
        return defaultValue;
    }
    else if (IsAdvancedAbortSignal(signal)) {
        return signal;
    }
    else {
        throw new TypeError(`Expected AdvancedAbortSignal or void as options.signal`);
    }
}
export function NormalizeICancellablePromiseOptions(options = {}, defaultValue) {
    if (IsObject(options)) {
        return {
            ...options,
            strategy: NormalizeICancellablePromiseOptionsStrategy(options.strategy, (defaultValue === void 0) ? void 0 : defaultValue.strategy),
            signal: NormalizeICancellablePromiseOptionsSignal(options.signal, (defaultValue === void 0) ? void 0 : defaultValue.signal),
        };
    }
    else {
        throw new TypeError(`Expected object or void as options`);
    }
}
export function NormalizeICancellablePromiseFinallyOptionsIncludeCancelled(includeCancelled, defaultValue = true) {
    if (includeCancelled === void 0) {
        return defaultValue;
    }
    else if (typeof includeCancelled === 'boolean') {
        return includeCancelled;
    }
    else {
        throw new TypeError(`Expected AdvancedAbortSignal or void as options.signal`);
    }
}
export function NormalizeICancellablePromiseFinallyOptions(options = {}, defaultValue) {
    if (IsObject(options)) {
        return {
            ...options,
            includeCancelled: NormalizeICancellablePromiseFinallyOptionsIncludeCancelled(options.includeCancelled, (defaultValue === void 0) ? void 0 : defaultValue.includeCancelled),
        };
    }
    else {
        throw new TypeError(`Expected object or void as options`);
    }
}
//# sourceMappingURL=functions.js.map